import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { translationChunksConfig, translations } from '@spartacus/assets';
import { OccConfig, provideConfig, provideFeatureToggles } from '@spartacus/core';
import {
  defaultCmsContentProviders,
  layoutConfig,
  mediaConfig,
} from '@spartacus/storefront';
import { environment } from 'src/environments/environment';

const occConfig: OccConfig = { backend: { occ: {} } };
// only provide the `occ.baseUrl` key if it is explicitly configured, otherwise the value of
// <meta name="occ-backend-base-url" > is ignored.
// This in turn breaks the deployment in CCv2.
// https://github.com/SAP/spartacus/issues/5886
occConfig.backend.occ.prefix = '/occ/v2/';
if (environment.occBaseUrl) {
  occConfig.backend.occ.baseUrl = environment.occBaseUrl;
}

const PRODUCT_TYPE = 'DEFAULT';

@NgModule({
  declarations: [],
  imports: [BrowserModule],
  providers: [
    provideFeatureToggles({
      searchBoxV2: false,
      showDeliveryOptionsTranslation: false,
      formErrorsDescriptiveMessages: false,
      showSearchingCustomerByOrderInASM: false,
      showStyleChangesInASM: false,
      shouldHideAddToCartForUnpurchasableProducts: false,
      useExtractedBillingAddressComponent: false,
      showBillingAddressInDigitalPayments: false,
      showDownloadProposalButton: false,
      pdfInvoicesSortByInvoiceDate: false,
      useProductCarouselBatchApi: false,
      productConfiguratorAttributeTypesV2: true,
      propagateErrorsToServer: false,
      ssrStrictErrorHandlingForHttpAndNgrx: false,
      productConfiguratorDeltaRendering: false,
      a11yRequiredAsterisks: false,
      a11yQuantityOrderTabbing: false,
      a11yNavigationUiKeyboardControls: false,
      a11yNavMenuExpandStateReadout: false,
      a11yOrderConfirmationHeadingOrder: false,
      a11yStarRating: false,
      a11yViewChangeAssistiveMessage: false,
      a11yReorderDialog: false,
      a11yPopoverFocus: false,
      a11yScheduleReplenishment: false,
      a11yScrollToTop: false,
      a11ySavedCartsZoom: false,
      a11ySortingOptionsTruncation: false,
      a11yExpandedFocusIndicator: false,
      a11yCheckoutDeliveryFocus: false,
      a11yMobileVisibleFocus: false,
      a11yOrganizationsBanner: false,
      a11yOrganizationListHeadingOrder: false,
      a11yCartImportConfirmationMessage: false,
      a11yReplenishmentOrderFieldset: false,
      a11yListOversizedFocus: false,
      a11yStoreFinderOverflow: false,
      a11yCartSummaryHeadingOrder: false,
      a11ySearchBoxMobileFocus: false,
      a11yFacetKeyboardNavigation: false,
      a11yUnitsListKeyboardControls: false,
      a11yCartItemsLinksStyles: false,
      a11yHideSelectBtnForSelectedAddrOrPayment: false,
      a11yFocusableCarouselControls: false,
      cmsGuardsServiceUseGuardsComposer: false,
      cartQuickOrderRemoveListeningToFailEvent: false,
      a11yKeyboardAccessibleZoom: false,
      a11yOrganizationLinkableCells: false,
      a11yVisibleFocusOverflows: false,
      a11yTruncatedTextForResponsiveView: false,
      a11ySemanticPaginationLabel: false,
      a11yPreventCartItemsFormRedundantRecreation: false,
      a11yPreventSRFocusOnHiddenElements: false,
      a11yMyAccountLinkOutline: false,
      a11yCloseProductImageBtnFocus: false,
      a11yNotificationPreferenceFieldset: false,
      a11yImproveContrast: false,
      a11yEmptyWishlistHeading: false,
      a11yScreenReaderBloatFix: false,
      a11yUseButtonsForBtnLinks: false,
      a11yNotificationsOnConsentChange: false,
      a11yDisabledCouponAndQuickOrderActionButtonsInsteadOfRequiredFields: false,
      a11yFacetsDialogFocusHandling: false,
      a11yStoreFinderAlerts: false,
      a11yFormErrorMuteIcon: false,
      a11yCxMessageFocus: false,
      a11yLinkBtnsToTertiaryBtns: false,
      a11yRepeatedPageTitleFix: false,
      a11yDeliveryModeRadiogroup: false,
      a11yNgSelectOptionsCount: false,
      a11yRepeatedCancelOrderError: false,
      a11yAddedToCartActiveDialog: false,
      a11yNgSelectMobileReadout: false,
      a11yQuickOrderAriaControls: false,
      a11yRemoveStatusLoadedRole: false,
      a11yDialogsHeading: false,
      occCartNameAndDescriptionInHttpRequestBody: false,
      cmsBottomHeaderSlotUsingFlexStyles: false,
      useSiteThemeService: false,
    }),
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      backend: occConfig.backend,
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        // TODO: adjust origins as necessary
        allowOrigin: 'localhost:9002, *.*.model-t.cc.commerce.ondemand.com:443, *.pharma.aventis.com:443, *.sanofiwebb.com:443',
      },
      context: {
        urlParameters: ['baseSite', 'language', 'currency'],
        baseSite: ['br'],
        currency: ['BRL'],
        language: ['pt'],
      },
      i18n: {
        resources: translations,
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
      features: {
        level: '6.0',
      },
    }),
    provideConfig({
      backend: {
        occ: {
          endpoints: {
            asmCustomerSearch: '/occ/v2/br/assisted-service/customers/search',
          },
        },
      },
    } as OccConfig),
  ],
})
export class SpartacusConfigurationModule { }
